import React, { Component } from "react";

class Header extends Component {
  render() {
    let name = "";
    let description = "";
    let city = "";
    let occupation = "";
    let networks = "";

    if (this.props.data.basics) {
      // var project = this.props.data.project;
      // var github = this.props.data.github;
      name = this.props.data.basics.name;
      description = this.props.data.basics.description;
      city = this.props.data.basics.location.city;
      occupation = this.props.data.basics.label;
      networks = this.props.data.basics.profiles.map(function (network) {
        return (
          <li key={network.network}>
            <a href={network.url}>
              <i /* style={{ color: "#11ABB0" }}  */className={network.className}></i>
            </a>
          </li>
        );
      });
    }

    return (
      <header id="home">
        <nav id="nav-wrap">
          <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
            Show navigation
          </a>
          <a className="mobile-btn" href="#home" title="Hide navigation">
            Hide navigation
          </a>

          <ul id="nav" className="nav">
            <li className="current">
              <a className="smoothscroll" href="#home">
                Home
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#about">
                About
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#resume">
                Resume
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#portfolio">
                Works
              </a>
            </li>
            <li>
              {/*               <a className="smoothscroll" href="#contact">
                Contact
              </a> */}
            </li>
          </ul>
        </nav>

        <div className="row banner">
          <div className="banner-text">
            <h1
              style={{
                textShadow:
                  "1px 0 0 #6E7881,0 1px 0 #6E7881,-1px 0 0 #6E7881,0 -1px 0 #6E7881",
              }}
              className="responsive-headline"
            >
              I'm {name}.
            </h1>
            <h3>
              <span
                style={{
                  textShadow:
                    "1px 0 0 #6E7881,0 1px 0 #6E7881,-1px 0 0 #6E7881,0 -1px 0 #6E7881",
                }}
              >
                I'm a {city} based <span>{occupation}</span>. {description}.
              </span>
            </h3>
            <hr />
            {/*            <ul className="social">
               <a href={project} className="button btn project-btn"><i className="fa fa-book"></i>Project</a>
               <a href={github} className="button btn github-btn"><i className="fa fa-github"></i>Github</a>
            </ul> */}
            <ul className="social">{networks}</ul>
          </div>
        </div>

        <p className="scrolldown">
          <a className="smoothscroll" href="#about">
            <i className="icon-down-circle"></i>
          </a>
        </p>
      </header>
    );
  }
}

export default Header;
